import object from 'lodash/object'

class SortParams {
  types
  constructor (params) {
    console.log(params)

    let catSort = []
    object.forOwn(this.sort(params, 'device_type'), (value) => {
      catSort.push(object.values(this.sort(value, 'category')))
    })
    this.types = this.format(catSort)
  }
  sort (parameters, sortBy) {
    let query = {}

    parameters.forEach((param) => {
      if (!object.has(query, param[sortBy].id)) {
        object.set(query, param[sortBy].id, [])
      }
      let array = object.get(query, param[sortBy].id)
      array.push(param)
      object.set(query, param[sortBy].id, array)
    })

    return query
  }
  format (catSort) {
    let types = []
    catSort.forEach(el => {
      let groups = []
      el.forEach(elem => {
        let params = []
        elem.forEach(element => {
          let param = {
            id: element.id,
            typeId: element.device_type.id,
            value: element.value,
            metric: element.metric.id,
            typeTitle: element.device_type.title,
            title: element.title,
            color: element.device_type.color,
            selected: false
          }
          params.push(param)
        })
        let group = {
          status: false,
          title: elem[0].category.title,
          params: params
        }
        groups.push(group)
      })
      let type = {
        status: false,
        typeId: el[0][0].device_type.id,
        color: el[0][0].device_type.color,
        name: el[0][0].device_type.title,
        groups: groups
      }
      types.push(type)
    })
    return types
  }
}

export default SortParams
